import { createAnalyticsStore } from "@/store/Analytic/create-chart-store";

export const useNewsStatDynamicBlocksStore = createAnalyticsStore(
  "newsStatDynamicBlocks",
  "Analytics/block/dynamics/:projectId"
);